<template>

    <div :class="classes" class="checkbox checkbox-styled">
        <input :id="'facet-type-'+option.id" @change="updateSelection($event)"
               type="checkbox"
               v-model="option.selected">
        <label :for="'facet-type-'+option.id">{{option.name}} <span
                class="result count">({{option.count}})</span></label>
    </div>

</template>

<script>
    export default {
        name: "FacetCheckboxItem",
        props: ['option', 'classes'],
        methods: {
            updateSelection($e) {
                this.$emit('change', $e);
            }
        }
    }
</script>

<style scoped>

</style>
